import React from 'react';
import FeaturePalette from '../../../components/FeaturePalette';

/**
 * PalettePanel component for GuiBuilder
 * Wrapper for FeaturePalette component with padding
 */
export default function PalettePanel({ familyId, familyName, linkedFamilies, placedFeatureNames }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', padding: '0.5rem' }}>
            <FeaturePalette
                familyId={familyId}
                familyName={familyName}
                linkedFamilies={linkedFamilies}
                placedFeatureNames={placedFeatureNames}
            />
        </div>
    );
}
